// quick-view.js.liquid
// Quick View: merges child products, Slick gallery (dots only) on the left, Fancybox-safe,
// Core vs Seasonal color groups, Size/Fit swatches, availability with strikethrough for OOS,
// Yotpo bottom-line, and auto-select first available variant with correct image on open.

(function() {
  // ---------- Utilities ----------
  function formatMoney(cents) {
    var n = parseInt(cents || 0, 10);
    return "$" + (n / 100).toFixed(2);
  }

  function sizedImage(src, sizeSuffix) {
    if (!src || typeof src !== "string") return "//barcomade.com/cdn/shop/t/147/assets/no-image.png?v=28716";
    if (/_\d+x\.(jpg|jpeg|png|webp)$/i.test(src)) return src;
    return src
      .replace(/\.jpg$/i, sizeSuffix + ".jpg")
      .replace(/\.jpeg$/i, sizeSuffix + ".jpg")
      .replace(/\.png$/i, sizeSuffix + ".png")
      .replace(/\.webp$/i, sizeSuffix + ".webp");
  }

  function stripHTML(html) {
    return (html || "").replace(/<[^>]*>/gm, "");
  }

  function escapeHTML(s) {
    return String(s || "").replace(/[&<>"']/g, function(ch) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]);
    });
  }

  function escapeAttr(s) {
    return String(s || "").replace(/"/g, '&quot;');
  }

  function toDataColorName(val) {
    return String(val || "")
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/\//g, "-");
  }

  function unique(arr) {
    var set = new Set();
    (arr || []).forEach(function(v){ if (v != null && v !== "") set.add(String(v)); });
    return Array.from(set);
  }

  function getUniqueValuesForOption(variants, optionIdx) {
    return unique((variants || []).map(function(v){ return v["option" + (optionIdx + 1)]; }));
  }

  function sameURL(a, b) {
    if (!a || !b) return false;
    return a.replace(/^https?:/, "") === b.replace(/^https?:/, "");
  }

  // ---------- Fancybox-safe open/close with fallback ----------
  function openModalInline(selector, onAfterShow, onAfterClose) {
    if (window.jQuery && $.fancybox && typeof $.fancybox.open === "function") {
      $.fancybox.open({
        src: selector,
        type: "inline",
        opts: {
          smallBtn: true,
          afterShow: function() { if (typeof onAfterShow === "function") onAfterShow(); },
          afterClose: function() {
            if (typeof onAfterClose === "function") onAfterClose();
          }
        }
      });
      return "fancybox-v3";
    }
    // Fallback
    var $el = $(selector);
    if ($el.length) {
      $el.css({
        display: "block",
        position: "fixed",
        top: "5%",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 99999,
        background: "#fff",
        padding: "16px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        width: "min(980px, 94vw)",
        maxHeight: "90vh",
        overflow: "auto",
        borderRadius: "10px"
      });

      if ($el.find(".qv-fallback-close").length === 0) {
        $el.prepend('<button class="qv-fallback-close" style="position:absolute;right:10px;top:10px;font-size:22px;line-height:22px;background:none;border:none;cursor:pointer;">×</button>');
        $el.on("click", ".qv-fallback-close", function() {
          $(document).find("body").css("overflow","unset");
          $el.hide().empty();
          $el.parent().hide();
          if (typeof onAfterClose === "function") onAfterClose();
        });
      }
      if (typeof onAfterShow === "function") onAfterShow();
      $(document).find("body").css("overflow","hidden");
      $el.parent().show();
      return "fallback";
    }
    return "none";
  }

  function closeModal(selector) {
    if (window.jQuery && $.fancybox && typeof $.fancybox.close === "function") {
      $.fancybox.close();
      return;
    }
    $(selector).hide().empty();
  }

  // ---------- Data merging ----------
 function buildUnifiedProduct(mainProduct, childProducts) {
  var children = Array.isArray(childProducts) ? childProducts : [];

  // --- Images ---
  var images = Array.isArray(mainProduct && mainProduct.images) ? mainProduct.images.slice() : [];
  for (var i = 0; i < children.length; i++) {
    var ch = children[i];
    if (!ch || !ch.product) continue;
    var imgs = ch.product.images;
    if (Array.isArray(imgs)) {
      for (var j = 0; j < imgs.length; j++) images.push(imgs[j]);
    }
  }

  // --- Main Variants ---
  var mainVariantItems = [];
  var mainVars = Array.isArray(mainProduct && mainProduct.variants) ? mainProduct.variants : [];
  for (var mv = 0; mv < mainVars.length; mv++) {
    var cvM = copyVariant(mainVars[mv]);
    if (cvM) mainVariantItems.push(cvM);
  }

  // --- Child Variants ---
  var childVariantItems = [];
  for (var c = 0; c < children.length; c++) {
    var child = children[c];
    if (!child || !child.product) continue;
    var childVars = Array.isArray(child.product.variants) ? child.product.variants : [];
    for (var k = 0; k < childVars.length; k++) {
      var cvC = copyVariant(childVars[k]);
      if (cvC) childVariantItems.push(cvC);
    }
  }

  // --- Keep them as array-of-arrays ---
 // Combine both arrays into one
var Variants = mainVariantItems.concat(childVariantItems);

  // --- Unified Object ---
  var unified = {
    title: mainProduct && mainProduct.title,
    vendor: mainProduct && mainProduct.vendor,
    handle: mainProduct && mainProduct.handle,
    description: mainProduct && mainProduct.description,
    options: normalizeOptions(mainProduct),
    images: dedupePreserveOrder(images),
    variants: Variants, // ✅ merged in loop
    _meta: {
      main: mainProduct,
      children: children.filter(Boolean)
    }
  };
    unified.images = dedupePreserveOrder(unified.images);
  unified.options = reconcileOptions(unified.options, unified.variants);

  return unified;
}





  function normalizeOptions(product) {
    if (!product || !Array.isArray(product.options)) return [];
    return product.options.map(function(o) {
      return (typeof o === "string") ? o : (o && o.name) ? o.name : "";
    }).filter(Boolean);
  }

  function reconcileOptions(optionNames, variants) {
    var set = new Set(optionNames.map(function(n){ return n.toLowerCase(); }));
    ["Color","Size","Fit"].forEach(function(name) {
      if (!set.has(name.toLowerCase())) {
        var exists = variants.some(function(v) {
          return ["option1","option2","option3"].some(function(k) {
            return (v[k + "_name"] || "").toLowerCase() === name.toLowerCase();
          });
        });
        if (exists) optionNames.push(name);
      }
    });
    return optionNames.slice(0,3);
  }

  function copyVariant(v) {
    var nv = Object.assign({}, v);
    if (typeof v.option1 !== "undefined" && !nv.option1_name) nv.option1_name = "Option1";
    if (typeof v.option2 !== "undefined" && !nv.option2_name) nv.option2_name = "Option2";
    if (typeof v.option3 !== "undefined" && !nv.option3_name) nv.option3_name = "Option3";
    return nv;
  }

  function flatten(arrays) { return [].concat.apply([], arrays); }
  function dedupePreserveOrder(arr) {
    var seen = new Set(), out = [];
    (arr || []).forEach(function(x) {
      if (!x || typeof x !== "string") return;
      if (!seen.has(x)) { seen.add(x); out.push(x); }
    });
    return out;
  }

  // ---------- Rendering ----------
  function renderQuickView(unified) {
    var containerId = "#quick-view";
    if ($(containerId).length === 0) $("body").append('<div id="quickview-parent"><div id="quick-view"></div></div>');
    var $qv = $(containerId).empty();

    var idxColor = unified.options.findIndex(function(n){ return n.toLowerCase() === "color"; });
    var idxSize  = unified.options.findIndex(function(n){ return n.toLowerCase() === "size"; });
    var idxFit   = unified.options.findIndex(function(n){ return n.toLowerCase() === "fit"; });

    var images = Array.isArray(unified.images) && unified.images.length ? unified.images : ["//barcomade.com/cdn/shop/t/147/assets/no-image.png?v=28716"];
    var slidesHTML = images.map(function(src) {
      var full = sizedImage(src, "_800x");
      return '<div><img src="' + full + '" alt="' + escapeHTML(unified.title || "") + '" style="width:100%;height:auto;display:block;border-radius:8px;"/></div>';
    }).join("");
    var galleryHTML = '<div class="qv-slider" style="width:100%;">' + slidesHTML + '</div>';

    var firstAvailable = (unified.variants || []).find(function(v){ return v.available; }) || (unified.variants || [])[0] || null;
    var priceText   = firstAvailable ? formatMoney(firstAvailable.price) : "$0.00";
    var compareText = (firstAvailable && firstAvailable.compare_at_price) ? formatMoney(firstAvailable.compare_at_price) : "";

    // Color groups: Core (main) and Seasonal (children)
    var coreColors = [];
    var seasonalColors = [];
   /* if (idxColor > -1) {
      coreColors = unique((unified._meta.main.variants || []).map(function(v){ return v["option" + (idxColor + 1)]; }));
      var seasonalVariants = flatten((unified._meta.children || []).map(function(p){ return p.variants || []; }));
      seasonalColors = unique(seasonalVariants.map(function(v){ return v["option" + (idxColor + 1)]; }));
      seasonalColors = seasonalColors.filter(function(val){ return coreColors.indexOf(val) === -1; });
    }*/
    if (idxColor > -1) {
        // --- Core Variants: main + special child handles (c1–c4) ---
        var coreVariants = (unified._meta.main.variants || []).slice();
        var coreChildVariants = flatten(
            (unified._meta.children || [])
            .filter(function(child) {
                if (!child.product) return false;
                return /c[1-4]/i.test(child.product.handle); // only c1–c4
            })
            .map(function(child) {
                return child.product.variants || [];
            })
        );
        coreVariants = coreVariants.concat(coreChildVariants);
        coreColors = unique(
            coreVariants.map(function(v) {
            return v["option" + (idxColor + 1)];
            })
        );
        var seasonalVariants = flatten(
            (unified._meta.children || [])
            .filter(function(child) {
                if (!child.product) return false;
                return /s[1-4]/i.test(child.product.handle); // only s1–s4
            })
            .map(function(child) {
                if (!child.product) return false;
                return child.product.variants || [];
            })
        );
        seasonalColors = unique(
            seasonalVariants.map(function(v) {
            return v["option" + (idxColor + 1)];
            })
        );
        seasonalColors = seasonalColors.filter(function(val) {
            return coreColors.indexOf(val) === -1;
        });
    }


    var sizes  = idxSize  > -1 ? getUniqueValuesForOption(unified.variants, idxSize)  : [];
    var fits   = idxFit   > -1 ? getUniqueValuesForOption(unified.variants, idxFit)   : [];

    function buildColorGroup(label, groupClass, values) {
      if (!values.length) return "";
      var items = values.map(function(v) {
        var colorName = toDataColorName(v);
        return '' +
          '<button type="button" class="qv-swatch qv-swatch--color" data-group="' + groupClass + '" data-value="' + escapeAttr(v) + '" aria-pressed="false" style="display:flex;align-items:center;border:none;background:none;padding:0;">' +
            '<span class="tooltip-parent" data-colorname="' + escapeAttr(colorName) + '" swatchName="' + escapeAttr(v) + '" style="position:relative;display:inline-block;width:25px;height:25px;border-radius:50%;border:1px solid #ccc;cursor:pointer;transition:0.1s all;">' +
              '<span class="tooltip-text">' + escapeAttr(v) + '</span>' +
            '</span>' +
          '</button>';
      }).join("");
      return (
        '<div class="qv-swatch-block ' + groupClass + '" style="margin:10px 0;">' +
          '<div class="qv-swatch-label" style="font-weight:700;margin-bottom:8px;">' + escapeHTML(label) + '</div>' +
          '<div class="qv-swatch-wrap" style="display:flex;gap:8px;flex-wrap:wrap;">' + items + '</div>' +
        '</div>'
      );
    }

    function buildTextSwatchBlock(label, groupClass, values) {
      if (!values.length) return "";
      var items = values.map(function(v) {
        return '<button type="button" class="qv-swatch" data-group="' + groupClass + '" data-value="' + escapeAttr(v) + '" aria-pressed="false">' + escapeHTML(v) + '</button>';
      }).join("");
      return (
        '<div class="qv-swatch-block ' + groupClass + '" style="margin:10px 0;">' +
          '<div class="qv-swatch-label" style="font-weight:600;margin-bottom:6px;">' + escapeHTML(label) + '</div>' +
          '<div class="qv-swatch-wrap" style="display:flex;gap:8px;flex-wrap:wrap;">' + items + '</div>' +
        '</div>'
      );
    }

    var colorGroupsHTML =
      buildColorGroup("Core", "qv-color qv-color-core", coreColors) +
      buildColorGroup("Seasonal", "qv-color qv-color-seasonal", seasonalColors);

    var swatchesHTML =
      colorGroupsHTML +
      buildTextSwatchBlock("Size",  "qv-size",  sizes)  +
      buildTextSwatchBlock("Fit",   "qv-fit",   fits);

    var variantHidden = '<input type="hidden" id="qv-variant-id" value="' + (firstAvailable ? firstAvailable.id : "") + '"/>';

    var plainDesc = stripHTML(unified.description);
    var shortDesc = plainDesc.length > 150 ? plainDesc.substring(0,150) + "..." : plainDesc;

    // Yotpo bottom-line container
    var yotpoHTML =
      '<div class="qv-yotpo" style="margin:6px 0 10px;">' +
        '<div class="yotpo bottomLine" ' +
          'data-appkey="" ' +
          'data-domain="" ' +
          'data-product-id="' + escapeAttr(String(unified._meta.main.id || "")) + '" ' +
          'data-name="' + escapeAttr(unified.title || "") + '" ' +
          'data-url="/products/' + escapeAttr(unified.handle || "") + '" ' +
          'data-image-url="' + escapeAttr(images[0] || "") + '" ' +
          'data-description="' + escapeAttr(shortDesc) + '" ' +
          'data-bread-crumbs="Collection"></div>' +
      '</div>';

    var modalHTML =
      '<div class="qv-content" style="display:flex;gap:20px;align-items:flex-start;min-width:280px;max-width:100%;width:min(980px, 94vw);">' +
        '<div class="qv-left" style="flex:1;min-width:260px;max-width:520px;">' + galleryHTML + '</div>' +
        '<div class="qv-right" style="flex:1;min-width:260px;padding:10px 20px;">' +
          '<h2 class="qv-product-title" style="margin:0 0 6px;">' + escapeHTML(unified.title || "") + '</h2>' +
          yotpoHTML +
          '<p class="qv-product-vendor" style="margin:0 0 10px;color:#666;">' + escapeHTML(unified.vendor || "") + '</p>' +
          '<div class="qv-price" style="margin:0 0 12px;display:flex;gap:10px;align-items:baseline;flex-wrap:wrap;">' +
            (compareText ? '<span class="qv-product-original-price" style="text-decoration:line-through;color:#999;">' + compareText + '</span>' : '') +
            '<span class="qv-product-price" style="font-weight:600;">' + priceText + '</span>' +
          '</div>' +
          '<p class="qv-product-description" style="margin:0 0 14px;color:#444;line-height:1.5;">' + escapeHTML(shortDesc) + '</p>' +
          swatchesHTML +
          variantHidden +
          '<div style="display:flex;gap:10px;align-items:center;margin:16px 0 18px;flex-wrap:wrap;">' +
            '<button class="qv-add-button" style="padding:10px 14px;background:#111;color:#fff;border:none;border-radius:4px;cursor:pointer;">Add to Cart</button>' +
          '</div>' +
          '<a href="/products/' + unified.handle + '" class="view-product" style="border-bottom: 1px solid #000;">View full product →</a>' +
        '</div>' +
      '</div>' +
      '<style>' +
      '@media (max-width: 768px) {' +
      '  #quick-view .qv-content { flex-direction: column; }' +
      '  #quick-view .qv-left, #quick-view .qv-right { min-width: 100%; max-width: 100%; }' +
      '}' +
      ' .qv-slider .slick-dots { position: relative; bottom: 0; margin-top: 10px; }' +
      ' .qv-slider .slick-dots li button:before { font-size: 10px; color: #999; }' +
      ' .qv-slider .slick-dots li.slick-active button:before { color: #111; }' +
      // Unavailable swatch visuals
      ' .qv-swatch.qv-unavailable { position: relative; opacity: 0.4; }' +
      ' .qv-swatch.qv-unavailable::after {' +
      '   content: ""; position: absolute; left: 50%; top: 50%; width: 120%; height: 2px;' +
      '   background: #c00; transform: translate(-50%, -50%) rotate(45deg); pointer-events:none;' +
      ' }' +
      '</style>';

    $qv.append(modalHTML);

    openModalInline(
      containerId,
      function onAfterShow() {
        initSlick($qv);
        // Auto-select the first available complete variant and update image immediately
        bindSwatches(unified, $qv, idxColor, idxSize, idxFit);
        bindAddToCart($qv);
        preselectInitial(unified, $qv, idxColor, idxSize, idxFit);
        refreshYotpo();
      },
      function onAfterClose() { $qv.empty(); }
    );
  }

  // ---------- Slick ----------
  function initSlick($context) {
    var $slider = $context.find(".qv-slider");
    if (!$slider.length || !$slider.children().length) return;
    if ($slider.hasClass("slick-initialized")) $slider.slick("unslick");
    $slider.slick({
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      mobileFirst: true
    });
  }

  // ---------- Yotpo ----------
  function refreshYotpo() {
    try {
      if (window.yotpo && typeof window.yotpo.refreshWidgets === "function") {
        window.yotpo.refreshWidgets();
      } else if (window.Yotpo && window.Yotpo.API && typeof window.Yotpo.API.refreshWidgets === "function") {
        window.Yotpo.API.refreshWidgets();
      }
    } catch(e) { /* ignore */ }
  }

  // ---------- Swatches and selection ----------
  function bindSwatches(product, $context, idxColor, idxSize, idxFit) {
    $context.off("click", ".qv-swatch").on("click", ".qv-swatch", function() {
      var $btn = $(this);
      if ($btn.prop("disabled")) return;
      var group = $btn.data("group");
      if (String(group).indexOf("qv-color") !== -1) {
        $context.find('.qv-color .qv-swatch').attr("aria-pressed", "false").removeClass("qv-selected");
      } else {
        $context.find('.' + group + ' .qv-swatch').attr("aria-pressed", "false").removeClass("qv-selected");
      }
      $btn.attr("aria-pressed", "true").addClass("qv-selected");
      updateSelections(product, $context, idxColor, idxSize, idxFit);
    });
    updateSelections(product, $context, idxColor, idxSize, idxFit);
  }

  function getCurrentSelection($context) {
    return {
      Color: valOrNull($context.find(".qv-color .qv-swatch.qv-selected").data("value")),
      Size:  valOrNull($context.find(".qv-size .qv-swatch.qv-selected").data("value")),
      Fit:   valOrNull($context.find(".qv-fit .qv-swatch.qv-selected").data("value"))
    };
  }
  function valOrNull(v) { return (v === undefined || v === null || v === "") ? null : String(v); }

  function updateSelections(product, $context, idxColor, idxSize, idxFit) {
    var sel = getCurrentSelection($context);

    function matches(v) {
      var c = idxColor > -1 ? v["option" + (idxColor + 1)] : null;
      var s = idxSize  > -1 ? v["option" + (idxSize  + 1)] : null;
      var f = idxFit   > -1 ? v["option" + (idxFit   + 1)] : null;
      if (sel.Color && c !== sel.Color) return false;
      if (sel.Size  && s !== sel.Size)  return false;
      if (sel.Fit   && f !== sel.Fit)   return false;
      return true;
    }

    function valuesAvailability(optionIdx) {
      var avail = new Map();
      var idx = optionIdx === 0 ? idxColor : optionIdx === 1 ? idxSize : idxFit;
      if (idx < 0) return avail;
      var values = getUniqueValuesForOption(product.variants, idx);
      values.forEach(function(val) {
        var possible = product.variants.some(function(v) {
          var c = idxColor > -1 ? (idxColor === idx ? val : v["option" + (idxColor + 1)]) : null;
          var s = idxSize  > -1 ? (idxSize  === idx ? val : v["option" + (idxSize  + 1)])  : null;
          var f = idxFit   > -1 ? (idxFit   === idx ? val : v["option" + (idxFit   + 1)])   : null;

          if (sel.Color && c !== sel.Color && idx !== idxColor) return false;
          if (sel.Size  && s !== sel.Size  && idx !== idxSize)  return false;
          if (sel.Fit   && f !== sel.Fit   && idx !== idxFit)   return false;

          var match =
            (idxColor < 0 || c === v["option" + (idxColor + 1)]) &&
            (idxSize  < 0 || s === v["option" + (idxSize  + 1)])  &&
            (idxFit   < 0 || f === v["option" + (idxFit   + 1)]);
          return match && v.available;
        });
        avail.set(val, possible);
      });
      return avail;
    }

    function applyAvailability(groupSelector, availabilityMap) {
      if (!availabilityMap || availabilityMap.size === 0) return;
      $context.find(groupSelector + " .qv-swatch").each(function() {
        var $sw = $(this);
        var val = $sw.data("value");
        var ok = availabilityMap.get(val);
        if (ok) {
          $sw.prop("disabled", false).css({opacity: 1}).removeClass("qv-unavailable").attr("aria-disabled", "false");
        } else {
          $sw.prop("disabled", true).addClass("qv-unavailable").attr("aria-disabled", "true");
        }
      });
    }

    var availColor = valuesAvailability(0);
    if (idxColor > -1) {
      applyAvailability(".qv-color-core", availColor);
      applyAvailability(".qv-color-seasonal", availColor);
    }
    if (idxSize  > -1) applyAvailability(".qv-size",  valuesAvailability(1));
    if (idxFit   > -1) applyAvailability(".qv-fit",   valuesAvailability(2));

    var chosen = null;
    var candidates = (product.variants || []).filter(function(v) { return matches(v) && v.available; });
    if (candidates.length) chosen = candidates[0];

    if (chosen) {
      $context.find(".qv-product-price").text(formatMoney(chosen.price));
      if (chosen.compare_at_price) {
        if (!$context.find(".qv-product-original-price").length) {
          $context.find(".qv-price").prepend('<span class="qv-product-original-price" style="text-decoration:line-through;color:#999;">' + formatMoney(chosen.compare_at_price) + '</span>');
        } else {
          $context.find(".qv-product-original-price").text(formatMoney(chosen.compare_at_price));
        }
      } else {
        $context.find(".qv-product-original-price").remove();
      }
      $context.find("#qv-variant-id").val(chosen.id);

      // Update slider to variant's featured image immediately
      if (chosen.featured_image && chosen.featured_image.src) {
        var target = sizedImage(chosen.featured_image.src, "_800x");
        var $slider = $context.find(".qv-slider");
        if ($slider.length && $slider.hasClass("slick-initialized")) {
          var foundIndex = -1;
          $slider.find("img").each(function(i) {
            if (sameURL(this.src, target)) { foundIndex = i; return false; }
          });
          if (foundIndex > -1) {
            $slider.slick("slickGoTo", foundIndex, true);
          } else {
            $slider.find(".slick-current img").attr("src", target);
          }
        } else {
          $context.find(".qv-slider img").first().attr("src", target);
        }
      }
    } else if (product.variants && product.variants[0]) {
      $context.find("#qv-variant-id").val(product.variants.id);
      $context.find(".qv-product-price").text(formatMoney(product.variants.price));
      if (product.variants.compare_at_price) {
        if (!$context.find(".qv-product-original-price").length) {
          $context.find(".qv-price").prepend('<span class="qv-product-original-price" style="text-decoration:line-through;color:#999;">' + formatMoney(product.variants.compare_at_price) + '</span>');
        } else {
          $context.find(".qv-product-original-price").text(formatMoney(product.variants.compare_at_price));
        }
      } else {
        $context.find(".qv-product-original-price").remove();
      }
    }
  }

  // Auto-select first available full variant and sync image immediately
  function preselectInitial(product, $context, idxColor, idxSize, idxFit) {
    var initial = (product.variants || []).find(function(v) { return v.available; }) || (product.variants || []) || null;
    if (!initial) return;

    if (idxColor > -1) clickIfExists($context, ".qv-color", initial["option" + (idxColor + 1)]);
    if (idxSize  > -1) clickIfExists($context, ".qv-size",  initial["option" + (idxSize  + 1)]);
    if (idxFit   > -1) clickIfExists($context, ".qv-fit",   initial["option" + (idxFit   + 1)]);

    updateSelections(product, $context, idxColor, idxSize, idxFit);
  }

  function clickIfExists($context, groupSelector, value) {
    if (!value) return;
    var $btn = $context.find(groupSelector + ' .qv-swatch[data-value="' + escapeAttr(value) + '"]');
    if ($btn.length) $btn.trigger("click");
  }

  function bindAddToCart($context) {
    $context.find(".qv-add-button").off("click.qv").on("click.qv", function() {
      var variantId = $context.find("#qv-variant-id").val();
      if (!variantId) { alert("Please select available options."); return; }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { id: variantId },
        dataType: "json",
        success: function() {
          closeModal("#quick-view");
          $(document).find("body").css("overflow","unset");
          $("#quickview-parent").hide();
          if (typeof theme !== "undefined" && theme.MiniCart && typeof theme.MiniCart.update === "function") {
            theme.MiniCart.update();
          } else {
            window.location.href = "/cart";
          }
        },
        error: function() { alert("Error adding to cart"); }
      });
    });
  }

  // ---------- Fetch and merge ----------
 function fetchProduct(handle) {
  return $.getJSON("/products/" + encodeURIComponent(handle) + ".js");
}

function fetchAllProducts(handles) {
  var valid = (handles || [])
    .map(function(s){ return (s || "").trim(); })
    .filter(Boolean);

  if (!valid.length) return $.Deferred().resolve([]).promise();

  // Build per-handle Deferreds that always resolve to { handle, product }
  var requests = valid.map(function(h) {
    var d = $.Deferred();
    fetchProduct(h)
      .done(function(p){ d.resolve({ handle: h, product: p || null }); })
      .fail(function(){ d.resolve({ handle: h, product: null }); }); // resolve, don't reject
    return d.promise();
  });

  // Wait for all, normalize single-result quirk
  return $.when.apply($, requests).then(function() {
    var args = Array.prototype.slice.call(arguments);
    return requests.length === 1 ? [args[0]] : args;
  });
}



  // ---------- Integration with global productMetafields ----------
  function getChildHandlesFromGlobal(mainHandle) {
    try {
      var list = (window.productMetafields && Array.isArray(window.productMetafields)) ? window.productMetafields : [];
      if (!list.length || !mainHandle) return [];
      var entry = list.find(function(p){
        return p && typeof p.handle === "string" && p.handle === mainHandle;
      });
      if (!entry || !entry.metafields) return [];
      var m = entry.metafields || {};
      var raw = [m.core1, m.core2, m.core3, m.core4, m.seas1, m.seas2, m.seas3, m.seas4];

      // Clean: remove null/undefined/""/"null"/"undefined", trim, dedupe preserving order
      var seen = new Set(), out = [];
      raw.forEach(function(x) {
        if (x === undefined || x === null) return;
        var s = String(x).trim();
        if (!s || s.toLowerCase() === "null" || s.toLowerCase() === "undefined") return;
        if (!seen.has(s)) { seen.add(s); out.push(s); }
      });
      return out;
    } catch(e) {
      return [];
    }
  }

  // ---------- Entry ----------
  $(document).ready(function() {
    $(document).on("click", ".quick-view", function(e) {
      e.preventDefault();

      var $btn = $(this);
      var mainHandle = $btn.data("handle");
      if (!mainHandle) return;

      // Use global mapping instead of data attributes
      var childHandles = getChildHandlesFromGlobal(mainHandle);

      fetchProduct(mainHandle)
        .done(function(mainProduct) {
          fetchAllProducts(childHandles)
            .done(function(children) {
              var unified = buildUnifiedProduct(mainProduct, children || []);
              renderQuickView(unified);
              $("#quick-view").find(".qv-color-core").find(".qv-selected").trigger("click");
            })
            .fail(function() {
              var unified = buildUnifiedProduct(mainProduct, []);
              renderQuickView(unified);
            });
        })
        .fail(function() {
          alert("Unable to load product. Please try again.");
        });
    });
  });
})();
